import { api } from "@/api";

export const FILE = Symbol("FILE");
import { mapActions } from "vuex";
export const documentAlreadyUploaded = ({ arquivo }) =>
  (arquivo && !arquivo[FILE]) || !arquivo;
import { LoadingRequest } from "@/mixins/LoadingMixin";
export default {
  mixins: [LoadingRequest],
  methods: {
    ...mapActions(["showAlertNotification"]),
    uploadDocument(file, transform) {
      const formData = new FormData();
      formData.set("arquivo", file);
      return this.withLoading(
        api
          .post("/arquivos/upload", formData)
          .then(({ data }) => {
            if (transform) {
              return transform(file, data);
            } else {
              return data;
            }
          })
          .catch(error => {
            this.showAlertNotification({
              message: `Não foi possível dar upload no arquivo ${file.name}`,
              type: "error"
            });
            return Promise.reject(error);
          })
      );
    },
    uploadDocuments(files, transform) {
      return files.reduce((p, file) => {
        return p.then(list =>
          this.uploadDocument(file, transform)
            .catch(error => error)
            .then(response => list.concat([response]))
        );
      }, Promise.resolve([]));
    },
    onPreviewFile(item) {
      const src = item.arquivo
        ? item.arquivo[FILE]
          ? URL.createObjectURL(item.arquivo[FILE])
          : item.arquivo.url
        : item.url;
      window.open(src);
      if (item.arquivo && item.arquivo[FILE])
        URL.revokeObjectURL(item.arquivo[FILE]);
    },
    addFiles(item, files) {
      return item.concat(
        files.map(file => ({
          arquivo: {
            [FILE]: file,
            nome: file.name
          }
        }))
      );
    },
    onRemoveFile(item, file) {
      return item.filter(document =>
        document.arquivo
          ? document.arquivo.nome !== file.arquivo.nome
          : document.nome !== file.nome
      );
    },
    uploadAndExtractZipFile(file, transform) {
      const formData = new FormData();
      formData.set("arquivo", file);
      return this.withLoading(
        api
          .post("/arquivos/UploadExtractZip", formData)
          .then(({ data }) => {
            let result = [];

            data.forEach(element => {
              if (transform) {
                result.push(transform(file, element));
              } else {
                result.push(element);
              }
            });
            return result;
          })
          .catch(error => {
            this.showAlertNotification({
              message: `Não foi possível dar upload no arquivo ${file.name}`,
              type: "error"
            });
            return Promise.reject(error);
          })
      );
    }
  }
};
